var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteselectdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.1699 0.147358H0.162222C0.308109 -0.024715 0.553813 -0.0247148 0.6997 0.138755L5.03024 4.99122L9.36078 0.130151H9.35311C9.49899 -0.0419223 9.7447 -0.0419221 9.89058 0.121548C10.0365 0.285017 10.0365 0.560334 9.89058 0.723804L5.28363 5.886V5.8774C5.13006 6.04087 4.88436 6.04087 4.73847 5.8774C4.73079 5.86879 4.73079 5.86879 4.73079 5.86879L0.123831 0.706596L0.116152 0.697993C-0.037413 0.525919 -0.0374131 0.250603 0.108474 0.0871329C0.108474 0.0785292 0.108474 0.078529 0.108474 0.078529L0.1699 0.147358Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteselectdown);
export default __webpack_public_path__ + "static/media/whiteselectdown.a0df5e7ce44b7497a65b872f11f80040.svg";
export { ForwardRef as ReactComponent };